import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs';

@Injectable()
export class LabsService {
  private subject = new Subject<number>();
  constructor() { }

  lab_number = 1;

    sendLab(num: number) {
        this.lab_number = num;
        this.subject.next(num);
    }

    clearLab() {
        this.lab_number = 1;
        this.subject.next();
    }

    getLab(): Observable<any> {
        return this.subject.asObservable();
    }

}



// WEBPACK FOOTER //
// ./src/app/labs.service.ts